export default __webpack_public_path__ + "static/media/sif-the-great-grey-wolf--left.64566497.jpg";